import  React, { useEffect } from "react";
import { CalendarHeader, CalendarGrid, LocationDetailView, LocationsGridView,LeaderboardView } from "./CalendarComponents";
import EmployeeOverlay from "./EmployeeOverlay";
import {NavigationMenu} from "./NavigationMenu";
import { COLOR_PALETTE, LOCATION_ICONS,availableLocations } from "../utils/constants";
import { UserProfile } from "./Profiles";
import { useNavigate, Outlet } from "react-router";
import { EmployeeSignIns } from "./Shared/Types";
import { fetchEmployeeData } from "../utils/api";

// Get the value from environment variable
const showLeaderboard = process.env.REACT_APP_SHOW_LEADERBOARD === "true";

const ManagerCalendar = () => {
  const nav = useNavigate();
    // Page routing
    const [activeView, setActiveView] = React.useState('calendar');

    // Calendar states
    const [currentDate, setCurrentDate] = React.useState<Date | null>(new Date());
    // Fix: Initialize selectedDate as null to prevent the modal from opening automatically
    const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
    const [selectedTab, setSelectedTab] = React.useState('Magni'); // 'All', 'Magni', 'Guest'

    // Search page
    const [searchQuery, setSearchQuery] = React.useState('');
    const [showAllSearch, setShowAllSearch] = React.useState(false);

    // Profile
    const [selectedUser, setSelectedUser] = React.useState<any>();
    const [profileTab, setProfileTab] = React.useState('locations'); // 'locations' or 'time'
    const [dateFilter, setDateFilter] = React.useState('month'); // 'week','month','year','all'
    // Additional month/year for Magni
    const [profileMonth, setProfileMonth] = React.useState<number | null>(null); 
    const [profileYear, setProfileYear] = React.useState<number | null>(null); 

    const [employeesList, setEmployeesList] = React.useState<EmployeeSignIns[]>([]);

    // Leaderboard
    const [leaderboardCategory, setLeaderboardCategory] = React.useState('visits'); // 'visits' or 'duration'
    const [leaderboardMonth, setLeaderboardMonth] = React.useState<number | null>(null); 
    const [leaderboardYear, setLeaderboardYear] = React.useState<number | null>(null); 

    // Locations view
    const [selectedLocation, setSelectedLocation] = React.useState<string | null>(null);
    const [locationTimeFilter, setLocationTimeFilter] = React.useState('day');
    const [locationSearchQuery, setLocationSearchQuery] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    // Helpers
    const prevMonth = () => {
      setCurrentDate(prev => {
        const d = prev === null ? new Date() : new Date(prev);
        d.setMonth(d.getMonth() - 1);
        return d;
      });
    };
    const nextMonth = () => {
      setCurrentDate(prev => {
        const d = prev === null ? new Date() : new Date(prev);
        d.setMonth(d.getMonth() + 1);
        return d;
      });
    };
    const handleDateClick = (date:Date) => {
      setSelectedDate(date);
      setSelectedTab('Magni');
    };
    const closePopup = () => setSelectedDate(null);
    const handleTabClick = (tab:any) => setSelectedTab(tab);

    // Search
    const handleSearch = (e:any) => {
      setSearchQuery(e.target.value);
      setShowAllSearch(false);
    };
    const filteredEmployees = searchQuery.trim() === ''
      ? []
      : employeesList.filter((emp:any) => emp.name.toLowerCase().includes(searchQuery.toLowerCase()));
    const displayResults = showAllSearch ? filteredEmployees : filteredEmployees.slice(0, 6);


    const filteredLocationUsers = locationSearchQuery.trim() === ''
      ? []
      : employeesList.filter((emp:any) => {
          // Check if the user has visited any location
          const hasVisitedAnyLocation = emp.signIns.some((s:any) => 
            s.action === 'in' && !s.isMainOffice
          );
          
          // If name matches and visited any location
          return emp.name.toLowerCase().includes(locationSearchQuery.toLowerCase()) && hasVisitedAnyLocation;
        });

    // Month/Year for calendar
    const monthOptions = [
      "January","February","March","April","May","June",
      "July","August","September","October","November","December"
    ];
    const currentYearNum = new Date().getFullYear();
    const yearOptions = [];
    for (let y = currentYearNum - 5; y <= currentYearNum + 5; y++) {
      yearOptions.push(y);
    }
    const handleMonthChange = (e:any) => {
      const newMonth = parseInt(e.target.value);
      setCurrentDate(prev => prev === null ? new Date() : new Date(prev.getFullYear(), newMonth, 1));
    };
    const handleYearChange = (e:any) => {
      const newYear = parseInt(e.target.value);
      setCurrentDate(prev => prev === null? new Date() :  new Date(newYear, prev.getMonth(), 1));
    };

    // Demo add random user with complete trip cycle - Updated to include sign-in events
    

    // View user profile
    const viewUserProfile = (userId:string) => {
      const user = employeesList.find((emp:any) => emp.name === userId);
      setSelectedUser(user);
      setActiveView('profile');
      setProfileTab('locations');
    };
    
    // Handle location selection
    const handleLocationSelect = (location:string) => {
      setSelectedLocation(location);
    };
    
    // Handle back to locations
    const handleBackToLocations = () => {
      setSelectedLocation(null);
    };

    useEffect(() => {
      // Load employees from localStorage on mount
      const loadEmployees = async () => {
      setLoading(true);
      const parsedData:EmployeeSignIns[] = await fetchEmployeeData();
      setEmployeesList(parsedData);
      setLoading(false);
      };

      loadEmployees();
    },[]);

    return (
      <div className="app-container">
        <NavigationMenu 
          activeView={activeView} 
          setActiveView={setActiveView} 
          showLeaderboard={showLeaderboard} 
        />
        <button className="nav-button" onClick={() => nav(-1)} style={{ backgroundColor: 'var(--apple-light-blue)' }} > HOME </button>
        {/* Top search bar - appears on all views except profile and calendar */}
        {activeView !== 'profile' && activeView !== 'calendar' && (
          <div className="top-search-container">
            <input
              type="text"
              className="search-bar"
              placeholder="Search employees..."
              value={searchQuery}
              onChange={handleSearch}
            />
            {searchQuery.trim() !== '' && (
              <>
                <div className="search-results">
                  {displayResults.length === 0 ? (
                    <p>No employees found.</p>
                  ) : (
                    displayResults.map((emp:any, index:number) => (
                      <div
                        key={emp.id}
                        className="result-item"
                        onClick={() => viewUserProfile(emp.name)}
                      >
                        <div
                          className="employee-initial"
                          style={{ backgroundColor: COLOR_PALETTE[index % COLOR_PALETTE.length].initial }}
                        >
                          {emp.name.charAt(0)}
                        </div>
                        <div>
                          <div className="employee-name">{emp.name}</div>
                          <div className="employee-type">{emp.type}</div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                {filteredEmployees.length > 6 && !showAllSearch && (
                  <button className="show-all-btn" onClick={() => setShowAllSearch(true)}>
                    Show all ({filteredEmployees.length})
                  </button>
                )}
              </>
            )}
          </div>
        )}

        {activeView === 'calendar' && (
          <div className="calendar-container">
            {loading ? (
              <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading calendar data...</p>
              </div>
            ) : (
              <>
          <CalendarHeader
            currentDate={currentDate === null ? new Date() : currentDate}
            prevMonth={prevMonth}
            nextMonth={nextMonth}
            handleMonthChange={handleMonthChange}
            handleYearChange={handleYearChange}
            monthOptions={monthOptions}
            yearOptions={yearOptions}
          />
          <CalendarGrid
            currentDate={currentDate === null ? new Date() : currentDate}
            employees={employeesList}
            onDateClick={handleDateClick}
          />
          {selectedDate && (
            <EmployeeOverlay
              date={selectedDate}
              employees={employeesList}
              selectedTab={selectedTab}
              onTabClick={handleTabClick}
              onClose={closePopup}
              viewUserProfile={viewUserProfile}
            />
          )}
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            
          </div>
              </>
            )}
          </div>
        )}

        {activeView === 'locations' && (
          <div className="locations-container">
            {selectedLocation ? (
              <LocationDetailView
                location={selectedLocation}
                employees={employeesList}
                timeFilter={locationTimeFilter}
                setTimeFilter={setLocationTimeFilter}
                onBack={handleBackToLocations}
                viewUserProfile={viewUserProfile}
              />
            ) : (
              <LocationsGridView
                employees={employeesList}
                timeFilter={locationTimeFilter}
                setTimeFilter={setLocationTimeFilter}
                onSelectLocation={handleLocationSelect}
                searchQuery={locationSearchQuery}
                setSearchQuery={setLocationSearchQuery}
              />
            )}
          </div>
        )}

        {activeView === 'profile' && selectedUser && (
          <UserProfile user={selectedUser} />

        )}

        {activeView === 'leaderboard' && showLeaderboard && (
          <LeaderboardView
            employees={employeesList}
            category={leaderboardCategory}
            setCategory={setLeaderboardCategory}
            leaderboardMonth={leaderboardMonth}
            setLeaderboardMonth={setLeaderboardMonth}
            leaderboardYear={leaderboardYear}
            setLeaderboardYear={setLeaderboardYear}
            viewUserProfile={viewUserProfile}
          />
        )}
        <Outlet context={{selectedUser}} />
      </div>
    );
  };

  export default ManagerCalendar;